// Action names should be imported from their respective action modules
import {
    ATTACHMENT_BEGIN,
    ATTACHMENT_SUCCESS,
    ATTACHMENT_FAILURE,
    ATTACHMENT_CLEAR

} from 'app/actions/AttachmentActions';

// Example initial state
const initialState = {
    item: {},
    isLoading: false,
    error: ''
};

// Return a new state object with updated attributes
export default function AttachmentReducer(state = initialState, action) {
    switch (action.type) {
        case ATTACHMENT_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ATTACHMENT_SUCCESS:
            return {
                ...state,
                item: action.payload.data,
                isLoading: false,
                error: ''
            }
        case ATTACHMENT_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                isLoading: false
            }
        case ATTACHMENT_CLEAR:
            return {
                ...state,
                item: {},
                isLoading: false
            }
        default:
            return state;
    }
};


export const attachmentError = state => {
    return state.error;
}

export const attachmentIsLoading = state => {
    return state.isLoading;
}

export const attachment = state => {
    return state.item;
}